module.exports = __webpack_public_path__ + "app/announcement/modals/modal-preview-announcement-2OHKxfbY.html";